import { useState } from 'react';
import { Layout } from './components/Layout';
import { CollectionSelector } from './components/CollectionSelector';
import { ItemSelector } from './components/ItemSelector';
import { FileUploader } from './components/FileUploader';
import { useCollections } from './hooks/useCollections';
import { useItems } from './hooks/useItems';
import { useUpload } from './hooks/useUpload';
import './styles/app.css';

function App() {
  const [selectedCollection, setSelectedCollection] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [search, setSearch] = useState('');

  const {
    collections,
    isLoading: collectionsLoading,
    error: collectionsError,
  } = useCollections();

  const {
    items,
    isLoading: itemsLoading,
    error: itemsError,
  } = useItems(selectedCollection, search);

  const { state: uploadState, upload, reset: resetUpload } = useUpload();

  const handleCollectionChange = (id: string) => {
    setSelectedCollection(id);
    setSelectedItem('');
    setSearch('');
    resetUpload();
  };

  const handleItemChange = (id: string) => {
    setSelectedItem(id);
    resetUpload();
  };

  const handleUpload = async (file: File) => {
    if (!selectedCollection || !selectedItem) return;

    await upload({
      collectionId: selectedCollection,
      itemId: selectedItem,
      file,
    });
  };

  return (
    <Layout>
      <div className="steps">
        <CollectionSelector
          collections={collections}
          selectedId={selectedCollection}
          onChange={handleCollectionChange}
          isLoading={collectionsLoading}
          error={collectionsError}
        />

        <ItemSelector
          items={items}
          selectedId={selectedItem}
          onChange={handleItemChange}
          search={search}
          onSearchChange={setSearch}
          isLoading={itemsLoading}
          error={itemsError}
          disabled={!selectedCollection}
        />

        <FileUploader
          onUpload={handleUpload}
          state={uploadState}
          disabled={!selectedCollection || !selectedItem}
          onReset={resetUpload}
        />
      </div>
    </Layout>
  );
}

export default App;
